<template>
  <div class="row wrapper border-bottom white-bg page-heading mb-2">
    <div class="col-lg-8 align-self-center">
      <div class="d-flex align-self-center justify-content-between">      
        <h2>{{ $t('navigations.key risk indicator') }}</h2>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="ibox-content">
    <!-- Data Grid Panel -->
    <div class="ibox-content data-grid-container">
      <div class="data-grid-header">
        <h6 class="mb-0">
          <i class="fa fa-table me-2"></i>
          {{ $t("navigations.key risk indicator") }}
        </h6>
        <div class="position-relative align-self-center">
          <img
            class="cursor-pointer"
            src="../../assets/img/create.png"
            width="17"
            height="17"
            alt="Create risk assessment data"
            @click="openCreateRiskModals"
          />
          <div class="tool-tip">{{ $t("navigations.create key risk indicator") }}</div>
        </div>
      </div>

      <div class="table-responsive custom-dark-table-wrapper table-scroll">
        <table class="table table-striped dark-table-head mb-0 fixed-column-table">
          <thead>
            <tr>
              <th>{{ $t("navigations.category id") }}</th>
              <th>{{ $t("navigations.category") }}</th>
              <th>{{ $t("navigations.subcategory") }}</th>
              <th>{{ $t("navigations.description") }}</th>
              <th>{{ $t("navigations.level of scrutiny") }}</th>
              <th class="text-center">{{ $t("navigations.edit") }}</th>
              <th class="text-center">{{ $t("navigations.actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in ractlist" :key="item.id">
              <td class="py-0">{{ item.categoryId }}</td>
              <td class="py-1">{{ item.category }}</td>
              <td class="py-1">{{ item.subCategory }}</td>
              <td class="py-1">
                <div>
                  <span>{{ item.discussionDetails && !showMoreDescription[item.id]
                    ? item.discussionDetails.substring(0, 40) + (item.discussionDetails.length > 40 ? '...' : '')
                    : item.discussionDetails }}</span>
                  <a
                    v-if="item.discussionDetails && item.discussionDetails.length > 120"
                    class="more-less-link ms-1"
                    @click.stop="showMoreDescription[item.id] = !showMoreDescription[item.id]"
                  >
                    {{ showMoreDescription[item.id] ? 'less' : 'more' }}
                  </a>
                </div>
              </td>
              <td class="py-1">{{ item.levelOfScrutiny }}</td>
              <td class="text-center">
                <i class="fa fa-edit edit-delete" title="Edit KRI" @click="EditRact(item.id)"></i>
              </td>
              <td class="text-center">
                <i class="fa fa-trash edit-delete" title="Delete KRI"></i>
              </td>
            </tr>
            <tr v-if="!ractlist.length">
              <td colspan="7" class="text-center text-muted">
                No data available
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-lg-12 d-flex justify-content-lg-end px-0 mt-1">
        <v-pagination
          v-model="currentTemplatePage"
          :pages="totalTemplatePages"
          :range-size="0"
          active-color="#f4f9ff"
          @update:modelValue="LoadData"
        />
      </div>

      <div class="d-flex justify-content-end mt-4">
        <div>
          <button class="btn btn-sm btn-outline-primary me-2">Export</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Create Modal -->
  <customModal
    v-if="openCreateRiskModal"
    :containermd="true"
    :footerShow="false"
    @closeModal="closeModal"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <span>Create Key Risk Indicator</span>
      </div>
    </template>
    <template #body>
      <div class="form-group row px-3 py-2">
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category id") }}</label>
          <input type="text" class="form-control" v-model="value.categoryId">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category") }}</label>
          <input type="text" class="form-control" v-model="value.category">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.sub category") }}</label>
          <input type="text" class="form-control" v-model="value.subCategory">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.level of scrutiny") }}</label>
          <input type="text" class="form-control" v-model="value.levelOfScrutiny">
        </div>
        <div class="col-lg-12 mb-1">
          <label class="col-form-label">{{ $t("navigations.description") }}</label>
          <textarea cols="30" rows="5" class="form-control" v-model="value.discussionDetails"></textarea>
        </div>
        <div class="col-lg-12 my-3 d-flex justify-content-end">
          <button class="cancel_btn py-1 px-4 mx-3" type="button" @click="clear()">
            {{ $t("navigations.clear") }}
          </button>
          <button class="btn btn-primary py-1 px-4" type="button" @click="saveClicked()">
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </template>
  </customModal>

  <!-- Edit Modal -->
  <customModal
    v-if="editRiskModal"
    :containermd="true"
    :footerShow="false"
    @closeModal="closeModal"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <span>Edit Key Risk Indicator</span>
      </div>
    </template>
    <template #body>
      <div class="form-group row px-3 py-2">
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category id") }}</label>
          <input type="text" class="form-control" v-model="value.categoryId">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.category") }}</label>
          <input type="text" class="form-control" v-model="value.category">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.sub category") }}</label>
          <input type="text" class="form-control" v-model="value.subCategory">
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.level of scrutiny") }}</label>
          <input type="text" class="form-control" v-model="value.levelOfScrutiny">
        </div>
        <div class="col-12 mb-1">
          <label class="col-form-label">{{ $t("navigations.description") }}</label>
          <textarea cols="30" rows="5" class="form-control" v-model="value.discussionDetails"></textarea>
        </div>
        <div class="col-lg-12 my-3 d-flex justify-content-end">
          <button class="cancel_btn py-1 px-4 mx-3" type="button" @click="clear()">
            {{ $t("navigations.clear") }}
          </button>
          <button class="btn btn-primary py-1 px-4" type="button" @click="updatedClicked()">
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script>
/* eslint-disable */
import VPagination from "@hennge/vue3-pagination";
import axios from "axios";
import store from "../../store/index";
import CustomModal from "../customModal/customModal.vue";

export default {
  name: "RactFileImport",
  components: {
    VPagination,
    CustomModal,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idtoken: "",
      totalCount: 0,
      pageindex: 1,
      pagesize: 10,
      value: {
        categoryId: "",
        category: "",
        subCategory: "",
        levelOfScrutiny: "",
        discussionDetails: "",
      },
      SortProperty: "createdDate",
      SortOrder: "desc",
      ractlist: [],
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      openCreateRiskModal: false,
      editRiskModal: false,
      showMoreDescription: {},
      editingRowId: null,
      editableCopy: {},
    };
  },
  async mounted() {
    this.idtoken = store.getters.getIdToken;
    await this.getRactData();
    window.addEventListener("studyIdChanged", async () => {
      await this.getRactData();
    });
  },
  methods: {
    async saveClicked() {
      if (this.editingRowId) {
        this.saveEdit(this.editingRowId);
      } else {
        await this.createRisk();
      }
    },

    async updatedClicked() {
      if (this.editingRowId) {
        await this.updateRisk(this.editingRowId);
        this.closeModal();
      }
    },

    async updateRisk(id) {
      try {
        const idtoken = store.getters.getIdToken;
        const payload = {
          id: id,
          studyId: store.getters.getStudyIs,
          siteId: "",
          siteCode: "",
          categoryId: this.value.categoryId,
          category: this.value.category,
          subCategory: this.value.subCategory,
          dataScope: "",
          dataScopeId: "",
          version: "",
          riskIndicator: "",
          discussionDetails: this.value.discussionDetails,
          coreOrExtendedKRI: "",
          generalOrSpecific: "",
          levelOfScrutiny: this.value.levelOfScrutiny,
          frequency: "",
          thresholdBasis: "",
          weighting: "",
          mitigationActions: "",
          phase: "",
          typeOfRisk: "",
          objectives: "",
          templateId: "",
          impactPoint: 0,
          probabilityPoint: 0,
          detectabilityPoint: 0,
          scorecard: "",
          riskLevelLabel: "",
          riskLevelColor: "",
        };
        await axios.put(`${this.baseurl}/forms/rbqm/update`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        this.closeModal();
        alert("Key Risk Indicator updated successfully");
        this.saveEdit(this.editingRowId);
        await this.getRactData();
      } catch (err) {
        console.error("Error updating risk assessment:", err);
        alert("Failed to update Key Risk Indicator");
      }
    },

    async createRisk() {
      try {
        const idtoken = store.getters.getIdToken;
        const payload = {
          studyId: store.getters.getStudyIs,
          siteId: "",
          siteCode: "",
          categoryId: this.value.categoryId,
          category: this.value.category,
          subCategory: this.value.subCategory,
          dataScope: "",
          dataScopeId: "",
          version: "",
          riskIndicator: "",
          discussionDetails: this.value.discussionDetails,
          coreOrExtendedKRI: "",
          generalOrSpecific: "",
          levelOfScrutiny: this.value.levelOfScrutiny,
          frequency: "",
          thresholdBasis: "",
          weighting: "",
          mitigationActions: "",
          phase: "",
          typeOfRisk: "",
          objectives: "",
          templateId: "",
          impactPoint: 0,
          probabilityPoint: 0,
          detectabilityPoint: 0,
          scorecard: "",
          riskLevelLabel: "",
          riskLevelColor: "",
        };
        await axios.post(`${this.baseurl}/forms/rbqm/create`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        await this.getRactData();
        this.closeModal();
        alert("Key Risk Indicator created successfully");
      } catch (err) {
        console.error("Error saving risk assessment:", err);
        alert("Failed to create Key Risk Indicator.");
      }
    },

    async EditRact(id) {
      try {
        this.editRiskModal = true;
        this.editingRowId = id;
        const idtoken = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/getriskindicator?id=${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.editableCopy = JSON.parse(JSON.stringify(response.data));
        this.value = {
          categoryId: response.data.categoryId || "",
          category: response.data.category || "",
          subCategory: response.data.subCategory || "",
          levelOfScrutiny: response.data.levelOfScrutiny || "",
          discussionDetails: response.data.discussionDetails || "",
        };
      } catch (err) {
        console.error("Error fetching risk indicator:", err);
        alert("Failed to fetch risk indicator data.");
      }
    },

    saveEdit(id) {
      const index = this.ractlist.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.ractlist.splice(index, 1, { ...this.editableCopy });
      }
      this.editingRowId = null;
      this.editableCopy = {};
    },

    cancelEdit() {
      this.editingRowId = null;
      this.editableCopy = {};
    },

    async openCreateRiskModals() {
      this.openCreateRiskModal = true;
    },

    async clear() {
      this.value = {
        categoryId: "",
        category: "",
        subCategory: "",
        levelOfScrutiny: "",
        discussionDetails: "",
      };
    },

    async closeModal() {
      this.value = {
        categoryId: "",
        category: "",
        subCategory: "",
        levelOfScrutiny: "",
        discussionDetails: "",
      };
      this.openCreateRiskModal = false;
      this.editRiskModal = false;
    },

    async getRactData() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/forms/rbqm/paginatedindicator?` +
            "&pageindex=" + this.currentTemplatePage +
            "&pagesize=" + this.pagesize +
            "&StudyId=" + store.getters.getStudyIs +
            "&SortProperty=" + this.SortProperty +
            "&SortOrder=" + this.SortOrder,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.ractlist = res.data.entities;
          this.totalCount = res.data.totalCount;
          this.totalTemplatePages = Math.ceil(this.totalCount / this.pagesize);
        })
        .catch((err) => {
          console.log("error..", err);
        });
    },

    LoadData(page) {
      this.currentTemplatePage = page;
      this.getRactData();
    },
  },
};
</script>

<style scoped>
/* ── Table head colour (matches CtqRegistry) ── */
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}

/* ── Table base ── */
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

/* ── Scroll wrappers (matches CtqRegistry) ── */
.table-scroll {
  max-height: 350px;
  overflow-y: auto;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

/* ── Fixed / sticky column table (matches CtqRegistry exactly) ── */
.fixed-column-table {
  --col-width: 80px;
  width: max-content;
  min-width: 100%;
}

.fixed-column-table th,
.fixed-column-table td {
  padding: 8px 12px;
  white-space: nowrap;
  background: #fff;
}

.fixed-column-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background: #1a6aa2;
  color: #fff;
}

/* Sticky last 2 action columns */
.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  position: sticky;
  right: 0;
  z-index: 3;
  width: var(--col-width);
  min-width: var(--col-width);
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  position: sticky;
  right: var(--col-width);
  z-index: 3;
  width: var(--col-width);
  min-width: var(--col-width);
}

/* Keep sticky header cells above body cells */
.fixed-column-table thead th:last-child,
.fixed-column-table thead th:nth-last-child(2) {
  z-index: 5;
}

/* ── edit-delete icon (matches CtqRegistry) ── */
.edit-delete {
  cursor: pointer;
  font-size: 0.9rem;
  color: #5b9bd5;
  transition: color 0.15s;
}

.edit-delete:hover {
  color: #1a6aa2;
}

/* ── Description more/less link (matches CtqRegistry) ── */
.more-less-link {
  color: #5b9bd5 !important;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
}

.more-less-link:hover {
  text-decoration: underline !important;
}

/* ── Data grid container ── */
.data-grid-container {
  display: block;
  margin-top: 1rem;
}

.data-grid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0;
}

/* ── Cancel button ── */
.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}
</style>